<template>
  <div class="modal fade create-new-user-modal" id="CreateUserModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar usuário</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateUser" @submit.prevent="createUserMethod">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar um usuário</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_user_created" class="form-label fw-medium"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_user_created"
                      placeholder="Digite o nome"
                      autocomplete="off"
                      required
                    />
                  </div>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="email_user_created" class="form-label fw-medium"
                      >Email</label
                    >
                    <input
                      type="email"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="email_user_created"
                      placeholder="Digite o email"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="cellphone_user_created" class="form-label fw-medium"
                      >Celular (opcional)</label
                    >                      
                      <input
                      id="cellphone_user_created"
                      ref="cellphone"
                      type="text"
                      name="cellphone"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite o celular"
                      @keyup="changeInformationInputs('cellphone')"
                      @input="applyMaskPhone"
                      maxlength="15"
                    />
                  </div>

                  <!-- Horários de Trabalho -->
                  <div class="mt-30 mb-4">
                    <h5 class="mb-4">Horários de Trabalho</h5>
                    <div v-for="(day, index) in daysOfWeek" :key="day" class="mb-3">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="'day_' + index"
                          v-model="workSchedule[index].active"
                        />
                        <label class="form-check-label fw-medium" :for="'day_' + index">
                          {{ day }}
                        </label>
                      </div>
                      <div v-if="workSchedule[index].active" class="ms-4">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <label :for="'start_' + index" class="form-label">Horário de início</label>
                            <input
                              type="time"
                              class="form-control"
                              :id="'start_' + index"
                              v-model="workSchedule[index].start_time"
                              required
                            />
                          </div>
                          <div class="col-md-6 mb-2">
                            <label :for="'end_' + index" class="form-label">Horário de fim</label>
                            <input
                              type="time"
                              class="form-control"
                              :id="'end_' + index"
                              v-model="workSchedule[index].end_time"
                              required
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <label :for="'lunch_start_' + index" class="form-label">Início do almoço (opcional)</label>
                            <input
                              type="time"
                              class="form-control"
                              :id="'lunch_start_' + index"
                              v-model="workSchedule[index].lunch_start"
                            />
                          </div>
                          <div class="col-md-6 mb-2">
                            <label :for="'lunch_end_' + index" class="form-label">Fim do almoço (opcional)</label>
                            <input
                              type="time"
                              class="form-control"
                              :id="'lunch_end_' + index"
                              v-model="workSchedule[index].lunch_end"
                            />
                          </div>
                        </div>
                      </div>
                      <hr v-if="index < daysOfWeek.length - 1" class="my-3">
                    </div>
                  </div>

                  <div class="mt-30 mb-4">
                    <h5 class="mb-3">Acesso as paginas</h5>
                    <div class="row">
                      <div
                        v-for="page in getAccessPages"
                        :key="page.key"
                        class="col-12 col-md-6 mb-2"
                      >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'create_access_page_' + page.key"
                            :value="page.key"
                            v-model="selectedAllowedPages"
                          />
                          <label class="form-check-label" :for="'create_access_page_' + page.key">
                            {{ page.label }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-30 mb-4">
                    <h5 class="mb-3">Usuarios que ele pode ver</h5>
                    <div class="row">
                      <div
                        v-for="user in getAllUsersList"
                        :key="user.id"
                        class="col-12 col-md-6 mb-2"
                      >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'create_visible_user_' + user.id"
                            :value="Number(user.id)"
                            v-model="selectedVisibleUserIds"
                          />
                          <label class="form-check-label" :for="'create_visible_user_' + user.id">
                            {{ user.name }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 mt-30">
                    <label class="d-block text-black fw-semibold mb-10">
                      Senha temporária
                    </label>
                    <input
                      ref="password_user_created"
                      type="password"
                      name="password"
                      id="password_user_created"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="**************"
                      @keyup="changeInformationInputs('password_user_created')"
                    />
                  </div>

                  <div class="form-group mb-5 mb-sm-0 mb-md-5 col-12">
                    <label class="d-block text-black fw-semibold mb-10">
                      Confirme a senha temporária
                    </label>
                    <input
                      ref="password_user_created_confirm"
                      type="password"
                      name="confirm_password"
                      id="password_user_created_confirm"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="**************"
                      @keyup="changeInformationInputs('password_user_created_confirm')"
                    />
                  </div>

                  <div class="form-text mb-15 mb-mb-15 mb-md-20 col-12 mt-3">
                    <strong>Você deverá orientar o usuário a realizar a troca da senha antes de começar a usar efetivamente o sistema</strong>
                  </div>

                  <div class="form-group col-12">
                    <div ref="error_password_message" class="error-password-message">
                      As senhas são diferentes !
                    </div>
                  </div>
                  
                  <div class="form-group col-12">
                    <div ref="error_password_message_caracters" class="error-password-message-caracters">
                      A senha precisa ter pelo menos 1 número e 1 caracter especial !
                    </div>
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreateUser" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateUser">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger create-new-user-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonCreateUser" class="btn btn-success">Criar usuário</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "CreateUserModal",
  data () {
    return {
      currentAcces: 2,
      selectedOperations: [],
      selectedAllowedPages: [],
      selectedVisibleUserIds: [],
      daysOfWeek: ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'],
      dayMapping: {
        'Segunda-feira': 'MONDAY',
        'Terça-feira': 'TUESDAY',
        'Quarta-feira': 'WEDNESDAY',
        'Quinta-feira': 'THURSDAY',
        'Sexta-feira': 'FRIDAY',
        'Sábado': 'SATURDAY',
        'Domingo': 'SUNDAY'
      },
      workSchedule: [
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' },
        { active: false, start_time: '', lunch_start: '', lunch_end: '', end_time: '' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      "getRolesList",
      "getOperations",
      "getAccessPages",
      "getAllUsersList"
    ])
  },
  watch: {
    getAccessPages: {
      handler(pages) {
        if(this.selectedAllowedPages.length === 0 && Array.isArray(pages)){
          this.selectedAllowedPages = pages.map((page) => page.key);
        }
      },
      immediate: true
    },
    getAllUsersList: {
      handler(users) {
        if(this.selectedVisibleUserIds.length === 0 && Array.isArray(users)){
          this.selectedVisibleUserIds = users.map((user) => Number(user.id));
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      "setAccessControl",
      "setAllUsersList"
    ]),
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    checkPassword(password){
      return /[0-9]/.test(password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/.test(password);
    },
    async createUserMethod(){
      const alertResponse = this.alertResponse;

      const name_user_created = document.getElementById("name_user_created").value;
      const email_user_created = document.getElementById("email_user_created").value;
      const cellphone_user_created = document.getElementById("cellphone_user_created").value;
      const password_user_created = document.getElementById("password_user_created").value;
      const password_user_created_confirm = document.getElementById("password_user_created_confirm").value;
      let error = false;

      if(
        name_user_created == "" ||
        email_user_created == "" ||
        password_user_created == "" ||
        password_user_created_confirm == ""
      ){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      if(name_user_created == ""){
        this.$refs.name_user_created.style.borderColor = "red";
        error = true;
      }

      if(password_user_created == ""){
        this.$refs.password_user_created.style.borderColor = "red";
        error = true;
      }
      
      if(password_user_created_confirm == ""){
        this.$refs.password_user_created_confirm.style.borderColor = "red";
        error = true;
      }

      if(password_user_created != password_user_created_confirm){
        this.$refs.password_user_created.style.borderColor = "red";
        this.$refs.password_user_created_confirm.style.borderColor = "red";
        this.$refs.error_password_message.style.display = "flex";
        error = true;
      } else {
        this.$refs.error_password_message.style.display = "none";
      }

      if(!this.checkPassword(password_user_created)){
        this.$refs.error_password_message_caracters.style.display = "flex";
        error = true;
      } else {
        this.$refs.error_password_message_caracters.style.display = "none";
      }

      if(error){
        return;
      }

      const objUserCreate = {
        "name": name_user_created,
        "email": email_user_created,
        "phone": cellphone_user_created,
        "password": password_user_created,
        "password_confirm": password_user_created_confirm,
        "working_hours": this.workSchedule.filter(schedule => schedule.active).map(schedule => {
          const day = this.daysOfWeek[this.workSchedule.indexOf(schedule)];
          return {
            day_of_week: this.dayMapping[day],
            start_time: schedule.start_time + ':00',
            init_lunch: schedule.lunch_start ? schedule.lunch_start + ':00' : null,
            end_lunch: schedule.lunch_end ? schedule.lunch_end + ':00' : null,
            end_time: schedule.end_time + ':00'
          };
        })
      }

      const buttonCreateUser = this.$refs.buttonCreateUser;
      buttonCreateUser.disabled = true;
      buttonCreateUser.innerHTML = "Criando usuario...";
      
      try {
        const response = await api.axios.post("/api/create/user", objUserCreate);

        if(response != undefined && response.status == 200){
          buttonCreateUser.innerHTML = "Salvando acessos...";
          await this.saveCreatedUserAccess(email_user_created);
          buttonCreateUser.innerHTML = "Usuario criado com sucesso !";
          window.location.reload();
        } else {
          buttonCreateUser.disabled = false;
          buttonCreateUser.innerHTML = "Criar usuario";
        }
      } catch(error) {
        if(error.response && error.response.data != undefined){
          buttonCreateUser.innerHTML = "Criar usuario";
        }
        console.log("error", error);
        buttonCreateUser.disabled = false;
        alertResponse(error.response && error.response.data ? error.response.data : "Erro ao criar usuario", true);
      }
    },
    async saveCreatedUserAccess(email) {
      const usersResponse = await api.axios.get('/api/all-users');
      const users = Array.isArray(usersResponse.data) ? usersResponse.data : [];
      const createdUser = users.find((user) => String(user.email).toLowerCase() === String(email).toLowerCase());

      if(!createdUser || !createdUser.id){
        return;
      }

      const visibleUserIds = [
        ...this.selectedVisibleUserIds.map((id) => Number(id)),
        Number(createdUser.id)
      ];

      await api.axios.post(`/api/users/${createdUser.id}/access-control`, {
        allowed_pages: this.selectedAllowedPages,
        visible_user_ids: [...new Set(visibleUserIds)]
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateUser").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateUser").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateUser");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_user_delete");
      if(password){
        password.value = "";
      }
    },
  },
  mounted() {
    this.setAccessControl();
    this.setAllUsersList();
  }
};
</script>
